export default ({
  history: {
    push,
  },
}) => (data) => {
  localStorage.setItem('token', data.login.token)
  push('/')
}
